<!-- 导航栏 -->
<template>
  <div :class="mobileClass('cm_nav_container')">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo cm_nav_box"
      mode="horizontal"
      @select="handleSelect"
      background-color="#4379D3"
      text-color="#fff"
      active-text-color="#ffd04b"
      :router="router"
    >
      <el-menu-item class="cm_nav_item" v-for="item in $store.state.comData.navList" :key="item.id" :index="item.path" :route="item.path" v-show="hasAlias(webConfigue,item.alias)">{{item.title}}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  
  export default {
  components: {},
  data() {
    //这里存放数据
    return {
      router: true,
      webConfigue:JSON.parse(window.localStorage.getItem("webConfigue")),
      windowWidth:document.documentElement.clientWidth
    };
  },
  //监听属性 类似于data概念
  computed: {
    mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
  },
  //监控data中的数据变化
  watch: {
    '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
  },
  //方法集合
  methods: {
    hasAlias:function(arr,alias){
      for(let i =0 ;i<arr.length;i++){
        if(arr[i][alias]!=""&&arr[i][alias]!=undefined&&arr[i][alias]!=null){
          return true
        }
      }
      return false
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      window.localStorage.setItem("activePath","")
    },
    saveRouter(item){
      window.localStorage.setItem("updataRouter",item)
      // this.$store.commit("updataRouter",item)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
};
</script>
<style>
.cm_nav_container {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cm_nav_box {
  display: flex;
  width: 1200px;
}
.cm_nav_item {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.cm_nav_sub_title{
  width: 100%;
  font-size: 18px;
}
.cm_nav_item>div{
  width: 100%;
  display: flex;
  justify-content: center;
}
.el-menu--horizontal > .el-menu-item{
  font-size: 18px;
}
.el-menu--horizontal > .el-menu-item.is-active{
  color: #fff!important;
  border-bottom: none!important;
  background: #2051A5!important;
  font-size:18px;
}
.el-menu--horizontal > .el-menu-item:hover{
  background: #2051A5!important;
}
.el-menu--horizontal > .el-menu-item{
  border: none;
}

/**手机适配 */
.mobile_cm_nav_container{
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile_cm_nav_container>.el-menu.el-menu--horizontal{
  display: flex;
  flex-wrap: wrap;
  background-color:#fff!important;
}
.mobile_cm_nav_container>.el-menu--horizontal > .el-menu-item{
  margin-top: 10px;
}
</style>